


const DiscordLogo = require("../assets/Discord.png");
const TwitterLogo = require("../assets/Twitter.png");
const GithubLogo = require("../assets/Github.png");
const Rectangle1 = require("../assets/Rectangle-1.png");
const Rectangle2 = require("../assets/Rectangle-2.png");
const LockDexImage = require("../assets/LockDEX.png");
const MoneyDexImage = require("../assets/MoneyDex.png");
const SecureDexImage = require("../assets/SecureDex.png");
const ClaimDexImage = require("../assets/ClaimDex.png");

const Images_Icons = { 
  DiscordLogo,
  TwitterLogo,
  GithubLogo,
  Rectangle1,
  Rectangle2,
  LockDexImage,
  SecureDexImage,
  MoneyDexImage,
  ClaimDexImage
}

export default Images_Icons;